import { Injectable } from "@angular/core";
import { DataService } from "app/shared/services/data.service";
import { ApiDependenciesService } from "app/api/services/api-dependencies.service";
import { downloadFileFromExtendedBlob } from 'app/shared/helpers/file-download-helpers';
import { SnackBarService } from 'app/shared/services/snack-bar.service';

@Injectable()
export class PuzzelDownloadService extends DataService<any> {
  divisionId: number = 1;

  constructor(private apiDependencies: ApiDependenciesService,
    public snackBar: SnackBarService
  ) {
    super(apiDependencies);
  }

  async download(activityId: number, sessionId: string) {
    const endpoint = `/divisions/${this.divisionId}/puzzel/portal/activity/${activityId}/download`

    await this.setEndpoint(endpoint)
      .getFileAsBlobWithPost(this.createPuzzelDownloadModel(activityId, sessionId))
      .then((response) => {
        downloadFileFromExtendedBlob(response);
      }).catch((error: any) => {
        if (error.data) {
          this.snackBar.error(" " + error.data);
        }
      });
  }

  private createPuzzelDownloadModel(ActvityId: number, SessionId: String) {
    return {
      actvityId: ActvityId,
      sessionId: SessionId,
    };
  }
}